import { lazy, Suspense } from 'react';
import BlobProfile from './BlobProfile';
import MessageBlobCaption from './MessageBlobCaption';
import MessageIllustration from './MessageIllustration';
import MessageImageCaption from './MessageImageCaption';
import MessageAnimation from './MessageAnimation';
import { jsx as _jsx } from "react/jsx-runtime";
const messageBlobCaption = ({
  imageUrl,
  imageHeight,
  centreMessageOnMobile,
  colorThemeOption,
  captionImage,
  captionImageHeight,
  blobBleed,
  blobBleedConfig,
  shouldShowDecorativeBlob,
  imageWidth,
  blobHeight,
  showBorder,
  isCard,
  shouldUseConfigOffsetFirefox
}) => {
  return {
    component: MessageBlobCaption,
    imageUrl,
    imageHeight,
    centreMessageOnMobile,
    colorThemeOption,
    captionImage,
    captionImageHeight,
    blobBleed,
    blobBleedConfig,
    shouldShowDecorativeBlob,
    imageWidth,
    blobHeight,
    showBorder,
    isCard,
    shouldUseConfigOffsetFirefox
  };
};
const blobProfile = ({
  imageUrl,
  colorThemeOption,
  blobBleed,
  imageHeight,
  blobBleedConfig
}) => ({
  component: BlobProfile,
  imageUrl,
  colorThemeOption,
  blobBleed,
  imageHeight,
  blobBleedConfig
});
const imageMessage = ({
  imageKey,
  altText
}) => ({
  component: MessageImageCaption,
  imageKey,
  altText
});
const illustration = ({
  illustrationName,
  height,
  imageHeights,
  colorThemeOption,
  topMargin
}) => Object.assign({
  component: MessageIllustration,
  illustrationName,
  height,
  imageHeights,
  topMargin
}, colorThemeOption && {
  colorThemeOption
});
const animation = ({
  imageUrl,
  renderBlob,
  colorThemeOption,
  shouldShowDecorativeBlob,
  blobBleed,
  imageHeight,
  imageWidth,
  blobBleedConfig,
  loop,
  isCard,
  blobHeight,
  topMargin
}) => ({
  component: MessageAnimation,
  imageUrl,
  renderBlob,
  colorThemeOption,
  shouldShowDecorativeBlob,
  blobBleed,
  imageHeight,
  imageWidth,
  blobBleedConfig,
  loop,
  blobHeight,
  isCard,
  topMargin
});
const CampaignAssistantHowItWorks = /*#__PURE__*/lazy(() => import('./CampaignAssistantHowItWorks'));
const campaignAssistant = () => ({
  component: () => /*#__PURE__*/_jsx(Suspense, {
    children: /*#__PURE__*/_jsx(CampaignAssistantHowItWorks, {})
  })
});
const AiBlogPosts = /*#__PURE__*/lazy(() => import('./AiBlogPosts'));
const blogGenerator = () => ({
  component: () => /*#__PURE__*/_jsx(Suspense, {
    children: /*#__PURE__*/_jsx(AiBlogPosts, {})
  })
});
const AiLandingPage = /*#__PURE__*/lazy(() => import('./AiLandingPageCreator'));
const landingPageCreator = () => ({
  component: () => /*#__PURE__*/_jsx(Suspense, {
    children: /*#__PURE__*/_jsx(AiLandingPage, {})
  })
});
const AIMarketingEmailMessage = /*#__PURE__*/lazy(() => import('./AiMarketingEmailCreator'));
const marketingEmailCreator = () => ({
  component: () => /*#__PURE__*/_jsx(Suspense, {
    children: /*#__PURE__*/_jsx(AIMarketingEmailMessage, {})
  })
});
const CheckYourEmail = /*#__PURE__*/lazy(() => import('./CheckYourEmailContent'));
const contentCheckYourEmail = () => ({
  component: () => /*#__PURE__*/_jsx(Suspense, {
    children: /*#__PURE__*/_jsx(CheckYourEmail, {})
  })
});
const InvoiceGenerator = /*#__PURE__*/lazy(() => import('./InvoiceGenerator'));
const invoiceGenerator = () => ({
  component: () => /*#__PURE__*/_jsx(Suspense, {
    children: /*#__PURE__*/_jsx(InvoiceGenerator, {})
  })
});
export const MessageTypes = {
  illustration,
  imageMessage,
  blobProfile,
  messageBlobCaption,
  animation,
  campaignAssistant,
  blogGenerator,
  landingPageCreator,
  contentCheckYourEmail,
  invoiceGenerator,
  marketingEmailCreator
};